import axios from 'axios';

const tokenEndpoint = process.env.REACT_APP_REALTIMEKIT_TOKEN_ENDPOINT?.trim();

/**
 * RealtimeKit participant tokens must be minted by a trusted backend.
 * Do not put the Cloudflare API token or account credentials in this app.
 */
export const getRealtimeKitToken = async (meetingId) => {
  if (!tokenEndpoint) {
    throw new Error(
      '尚未設定 REACT_APP_REALTIMEKIT_TOKEN_ENDPOINT，無法取得教室連線憑證。'
    );
  }

  if (!meetingId) {
    throw new Error('網址中沒有有效的教室 ID。');
  }

  const response = await axios.get(
    `${tokenEndpoint.replace(/\/+$/, '')}/${encodeURIComponent(meetingId)}`,
    {
      headers: { Accept: 'application/json' },
      withCredentials:
        process.env.REACT_APP_REALTIMEKIT_TOKEN_WITH_CREDENTIALS === 'true',
    }
  );

  // Support both { token } and { data: { token } } backend responses.
  return response.data?.data?.token ? response.data.data : response.data;
};
